import React from 'react';

/* A note when using this component - you will need to pass a fill color if you want anything other than black. */

export const BellIcon = props => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M8.00008 14.5C8.73341 14.5 9.33341 13.9 9.33341 13.1667H6.66675C6.66675 13.9 7.26675 14.5 8.00008 14.5ZM12.0001 10.5V7.16667C12.0001 5.12 10.9134 3.40667 9.00008 2.95333V2.5C9.00008 1.94667 8.55341 1.5 8.00008 1.5C7.44675 1.5 7.00008 1.94667 7.00008 2.5V2.95333C5.09341 3.40667 4.00008 5.11333 4.00008 7.16667V10.5L2.66675 11.8333V12.5H13.3334V11.8333L12.0001 10.5ZM10.6667 11.1667H5.33341V7.16667C5.33341 5.51333 6.34008 4.16667 8.00008 4.16667C9.66008 4.16667 10.6667 5.51333 10.6667 7.16667V11.1667Z" />
  </svg>
);
